import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface ParentsOnboardingBatchesEmailReleaseParams {
  batchId: string;
}

export interface ParentsOnboardingBatchesEmailReleaseResponse {
  success: boolean;
  message: string;
}

export const parentsOnboardingBatchesEmailRelease = async ({
  batchId,
}: ParentsOnboardingBatchesEmailReleaseParams) => {
  const response =
    await baseAPI.post<ParentsOnboardingBatchesEmailReleaseResponse>(
      `/parents/onboarding/batches/${batchId}/release-email`,
      {},
    );

  return response.data;
};

export const useParentsOnboardingBatchesEmailReleaseMutation = () => {
  return useMutation({
    mutationFn: parentsOnboardingBatchesEmailRelease,
    onSuccess: (_, { batchId }) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENTS_ONBOARDING_BATCHES],
      });

      void queryClient.invalidateQueries({
        predicate(query) {
          return (
            query.queryKey[0] === KEYS.PARENTS_ONBOARDING_BATCHES_BY_ID &&
            query.queryKey[1] === batchId
          );
        },
      });
    },
  });
};
